import React, { useState, useEffect } from 'react';
import Navigation from './components/Navigation';
import HomePage from './components/HomePage';
import AboutPage from './components/AboutPage';
import AcademicsPage from './components/AcademicsPage';
import AdmissionsPage from './components/AdmissionsPage';
import ContactPage from './components/ContactPage';
import AdministrationPage from './components/AdministrationPage';
import ClubsPage from './components/ClubsPage';
import NoticePage from './components/NoticePage';
import GalleryPage from './components/GalleryPage';
import Footer from './components/Footer';
import GovernmentServices from './components/GovernmentServices';
import { contentData } from './data/contentData';

const App: React.FC = () => {
  const [currentPage, setCurrentPage] = useState<string>('home');
  const [language, setLanguage] = useState<'en' | 'bn'>('bn');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // Hide loading screen after component mounts
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
      const loadingScreen = document.getElementById('loading-screen');
      if (loadingScreen) {
        loadingScreen.style.display = 'none';
      }
    }, 1500);
  }, []);

  const content = contentData[language];

  return (
    <div className="bg-gray-50 overflow-x-hidden">
      {/* Loading Screen */}
      {isLoading && (
        <div id="loading-screen" className="fixed inset-0 bg-white z-50 flex items-center justify-center">
          <div className="text-center">
            <div className="loading-spinner mx-auto mb-4"></div>
            <p className="text-gray-600">Loading...</p>
          </div>
        </div>
      )}

      <Navigation 
        currentPage={currentPage} 
        setCurrentPage={setCurrentPage}
        language={language}
        setLanguage={setLanguage}
        content={content}
      />
      
      <main className="pt-24 overflow-x-hidden">
        {currentPage === 'home' && <HomePage content={content} />}
        {currentPage === 'about' && <AboutPage content={content} />}
        {currentPage === 'administration' && <AdministrationPage content={content} />}
        {currentPage === 'academics' && <AcademicsPage content={content} />}
        {currentPage === 'admissions' && <AdmissionsPage content={content} />}
        {currentPage === 'clubs' && <ClubsPage content={content} />}
        {currentPage === 'gallery' && <GalleryPage content={content} />}
        {currentPage === 'notice' && <NoticePage content={content} />}
        {currentPage === 'contact' && <ContactPage content={content} />}
      </main>
      
      {/* Government Services - Fixed on all pages before footer */}
      <GovernmentServices />
      
      <Footer content={content} />
    </div>
  );
};

export default App;
